/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, reason: NonNullable<unknown> }} Media_Upload_File_ErrorInputs */

const vi_media_upload_file_error = /** @type {(inputs: Media_Upload_File_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.reason}`)
};

/**

* @param {Media_Upload_File_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_upload_file_error = /** @type {((inputs: Media_Upload_File_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Upload_File_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_upload_file_error(inputs)
});